import React from "react";
import aside_img from "../../assets/icons/home_about.svg";
import { ArrowRight, Tally1 } from "lucide-react";
import dr_hemanth from "../../assets/images/dr_hemanth.webp";

const AboutMe = () => {
  return (
    <div className="relative ">
      <div className="bottom-0 right-0 absolute">
        <img src={aside_img} alt="" />
      </div>
      <div data-aos="fade-up" className="xl:w-[1200px] flex lg:flex-row flex-col lg:gap-8 gap-8 w-11/12  mx-auto lg:py-[120px] md:py-24 py-12">
        <div className="lg:w-2/3 relative  xl:pe-16 lg:pe-8 flex flex-col xl:gap-2 gap-2 ">
          <h3 className="text-2xl 2xl:text-6xl xl:text-5xl lg:text-4xl md:text-3xl font-bold text-matcha ">
            Dr. Hemanth Makineni
          </h3>
          <h4 className="flex md:flex-row flex-col text-lg md:text-xl items-center font-bold text-[#B87333] ">
            MS (General Surgery) <Tally1 className="ps-2 md:block hidden" />
            M.Ch (Surgical Oncology)
          </h4>
          <h4 className="flex flex-row text-base font-bold text-[#1d9e75] ">
            Director, ARKA Hospital and Research Institute , Surgical Oncologist
          </h4>
          <p className="text-base text-matcha font-normal pb-1 pt-1.5 text-left">
            Dr. Hemanth Makineni is a compassionate and outcome-driven Surgical
            Oncologist with over a decade of experience and 5,000+ successful
            cancer surgeries to his credit. He specializes in Head & Neck,
            Breast, GI & HPB, Urological, and Gynecologic oncology procedures.
            Dr. Makineni is the Director and Consultant Surgical Oncologist at
            Arka Hospital and a visiting consultant at major hospitals across
            Guntur. A Fellow of the Indian Association of Gastrointestinal and
            Endoscopic Surgeons, he emphasizes minimal complications, patient
            comfort, and collaborative care for the best outcomes.
          </p>
          <p className="text-base text-matcha font-normal pb-1">
            With over 10 years of experience and a record of 5,000+ successful
            cancer surgeries, he has transformed countless lives through
            precision, expertise, and empathy.
          </p>

          <button className="bg-matcha py-3 px-10 xl:absolute bottom-0 text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-4 rounded-xl hover:bg-transparent hover:text-matcha duration-200 transition">
            Book An Appointment <ArrowRight strokeWidth={1} />
          </button>
        </div>
        <div className=" relative flex flex-col overflow-hidden  lg:w-1/3 rounded-xl ">
          <img loading="lazy" src={dr_hemanth} alt="" />
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
